import { render, staticRenderFns } from "./FostersSupportHBF.vue?vue&type=template&id=7aa8cc59&scoped=true"
import script from "./FostersSupportHBF.vue?vue&type=script&lang=js"
export * from "./FostersSupportHBF.vue?vue&type=script&lang=js"
import style0 from "./FostersSupportHBF.vue?vue&type=style&index=0&id=7aa8cc59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa8cc59",
  null
  
)

export default component.exports